import { Checkbox, Grid, Text, TextInput, Title } from "@mantine/core";
import { UseFormReturnType } from "@mantine/form/lib/use-form";
import React from "react";
import { MerchantOnboardingFormValues } from "../../../../type/merchant-onboarding-form-values.types";

interface WebsiteLinksProps {
  form: UseFormReturnType<MerchantOnboardingFormValues>;
}
function WebsiteLinks(props: WebsiteLinksProps) {
  const { form } = props;
  const label = {
    businessWebsiteUrl: "Business website (Optional)",
    facebookUrl: "Facebook (Optional)",
    twitterUrl: "Twitter (Optional)",
    instagramUrl: "Instagram (Optional)",
    tiktokUrl: "Tiktok (Optional)",
    isBusinessWebsiteUnderDevelopment: "Website is under construction",
  };
  const placeHolder = {
    businessWebsiteUrl: "Business website",
    facebookUrl: "Facebook link",
    twitterUrl: "Twitter link",
    instagramUrl: "Instagram link",
    tiktokUrl: "Tiktok link",
  };
  return (
    <>
      <Grid>
        <Grid.Col>
          <Title order={3}>Website</Title>
          <Text size="xs" color="grey">
            Provide the URL of your website or any social media page.
          </Text>
        </Grid.Col>
        <Grid.Col>
          <TextInput
            placeholder={placeHolder.businessWebsiteUrl}
            label={label.businessWebsiteUrl}
            value={form.values.businessWebsiteUrl}
            onChange={(event) => {
              form.setFieldValue(
                "businessWebsiteUrl",
                event.currentTarget.value
              );
            }}
            error={form.errors.businessWebsiteUrl}
            data-cy="businessWebsiteUrl"
          />
        </Grid.Col>
        <Grid.Col xs={12} sm={6}>
          <TextInput
            placeholder={placeHolder.facebookUrl}
            label={label.facebookUrl}
            value={form.values.facebookUrl}
            onChange={(event) => {
              form.setFieldValue("facebookUrl", event.currentTarget.value);
            }}
            error={form.errors.facebookUrl}
            data-cy="facebookUrl"
          />
        </Grid.Col>
        <Grid.Col xs={12} sm={6}>
          <TextInput
            placeholder={placeHolder.twitterUrl}
            label={label.twitterUrl}
            value={form.values.twitterUrl}
            onChange={(event) => {
              form.setFieldValue("twitterUrl", event.currentTarget.value);
            }}
            error={form.errors.twitterUrl}
            data-cy="twitterUrl"
          />
        </Grid.Col>
        <Grid.Col xs={12} sm={6}>
          <TextInput
            placeholder={placeHolder.instagramUrl}
            label={label.instagramUrl}
            value={form.values.instagramUrl}
            onChange={(event) => {
              form.setFieldValue("instagramUrl", event.currentTarget.value);
            }}
            error={form.errors.instagramUrl}
            data-cy="instagramUrl"
          />
        </Grid.Col>
        <Grid.Col xs={12} sm={6}>
          <TextInput
            placeholder={placeHolder.tiktokUrl}
            label={label.tiktokUrl}
            value={form.values.tiktokUrl}
            onChange={(event) => {
              form.setFieldValue("tiktokUrl", event.currentTarget.value);
            }}
            error={form.errors.tiktokUrl}
            data-cy="tiktokUrl"
          />
        </Grid.Col>
        <Grid.Col>
          <Checkbox
            checked={form.values.isBusinessWebsiteUnderDevelopment}
            onChange={(event) =>
              form.setFieldValue(
                "isBusinessWebsiteUnderDevelopment",
                event.currentTarget.checked
              )
            }
            label={label.isBusinessWebsiteUnderDevelopment}
            data-cy="isBusinessWebsiteUnderDevelopment"
          />
        </Grid.Col>
      </Grid>
    </>
  );
}

export default WebsiteLinks;
